module.exports = __webpack_public_path__ + "static/img/2.6288dd80.png";